import { useTranslation } from "react-i18next";
import { faPenNib } from "@fortawesome/sharp-solid-svg-icons";
import { faSquarePollVertical } from "@fortawesome/pro-solid-svg-icons";
import LogoGPBlue from "@@/public/img/shared/logo_greenplayer_blue.png"
import Bornes from "@@/public/img/shared/Bornes.png";
import Kiosks from "@@/public/img/shared/Kiosks.png";
import Screens from "@@/public/img/shared/Screens.png";
import Medical from "@@/public/img/sectors/hospitalBenefits.webp";
import Company from "@@/public/img/sectors/companies-benefits.webp";
import Airport from "@@/public/img/sectors/airport-benefits.webp";
import Cities from "@@/public/img/sectors/cities_landing.webp";
import Transport from "@@/public/img/sectors/transport_thumbnail.webp";
import Retail from "@@/public/img/sectors/retail_thumbnail.webp";
import Education from "@@/public/img/sectors/education_thumbnail.webp";

import { HEADER_CATEGORY } from "./Header";
import {JSX} from "react";

import DropdownItem from "./DropdownItem";

import { useHeaderCategoryContext } from "@@/hooks/contexts/headerCategroyContext";

export default function DropdownContent(): JSX.Element {
	const { hoveredCategory, } = useHeaderCategoryContext();
	const { t, } = useTranslation();

	const solutionContent = (
		<>
			<div className={`d-flex flex-column w-fit min-w-100-mobile gap-1 gap-0-mobile`}>
				<p className={`color-blue subcategorie`}>{t('software')}</p>
				<ul className={`list-none w-fit flex-1 align-stretch min-w-100-mobile gap-0-mobile`}>
					<li className={`h-100`}>
						<DropdownItem
							title={t('greenplayer')}
							className={`min-h-100`}
							link="/solutions/greenplayer"
							img={LogoGPBlue}
							imgClassName={`w-2 h-2`}
							colors={{
								background: "#E7F8FF",
								backgroundHover: "#7DCDF2",
							}}
						/>
					</li>
				</ul>
			</div>
			<div className={`d-flex flex-column flex-1 gap-1 gap-0-mobile`}>
				<p className={`color-blue subcategorie`}>{t('material')}</p>
				<ul className={`list-none d-flex gap-1 flex-1 flex-column-mobile gap-0-mobile`}>
					<li className={`flex-1`}>
						<DropdownItem
							title={t('bornes')}
							link="/solutions/kiosks"
							img={Bornes}
							colors={{
								background: "#E7F8FF",
								backgroundHover: "#7DCDF2",
							}}
						/>
					</li>
					<li className={`flex-1`}>
						<DropdownItem
							title={t('totems')}
							link="/solutions/totems"
							img={Kiosks}
							colors={{
								background: "#E7F8FF",
								backgroundHover: "#7DCDF2",
							}}
						/>
					</li>
					<li className={`flex-1`}>
						<DropdownItem
							title={t("screens")}
							link="/solutions/screens"
							img={Screens}
							colors={{
								background: "#E7F8FF",
								backgroundHover: "#7DCDF2",
							}}
						/>
					</li>
				</ul>
			</div>
		</>
	);

	const hardwarContent = (
		<>
			<DropdownItem
				title={t("stylus_22h")}
				description={t("stylus_22h_description")}
				link="/hardware/stylus-22h"

			/>
			<DropdownItem
				title={t("stylus_22v")}
				description={t("stylus_22v_description")}
				link="/hardware/stylus-22v"
			/>
		</>
	);

	const sectorsContent = (
		<>
			<DropdownItem
				title={t("medical")}
				link="/sectors/hospital_medical"
				bgImg={Medical}
			/>
			<DropdownItem
				title={t("company")}
				link="/sectors/offices_companies"
				bgImg={Company}
			/>
			<DropdownItem
				title={t("airport")}
				link="/sectors/airport"
				bgImg={Airport}
			/>
			<DropdownItem
				title={t("cities")}
				link="/sectors/cities"
				bgImg={Cities}
			/>
			<DropdownItem
				title={t("transport")}
				link="/sectors/transport"
				bgImg={Transport}
			/>
			<DropdownItem
				title={t("retail")}
				link="/sectors/retail"
				bgImg={Retail}
			/>
			<DropdownItem
				title={t("eductation")}
				link="/sectors/education"
				bgImg={Education}
			/>
		</>
	);

	return (
		<>
			{hoveredCategory === HEADER_CATEGORY.SOLUTIONS && solutionContent}
			{hoveredCategory === HEADER_CATEGORY.SECTORS && sectorsContent}
		</>
	);
}
